<template>
  <Wrapper
    ref="wrapper"
    type-list="followers"
    :item-source="fetchClanFollows"
    has-search
    :dummy-props="{
      headerText: $t('_web_account-list_dummy_clan_followers', ''),
      text: $t('_web_account-list_dummy_clan_followers_subheader', ''),
    }"
  >
    <ListItemAccount
      :key="user.login"
      slot-scope="{ user }"
      v-bind="{
        type: user.type,
        avatar: user.avatar,
        name: $filters.displayName(user),
        accountId: user.login,
        approved: user.approved,
        role: user.role,
        vanityId: user.vanityId || user.vanity_id,
      }"
      class="mb-4"
    >
      <HeraFormBtn
        v-if="account.canManage"
        slot="action"
        class=""
        :class="inviteClanBtnClass(user)"
        :loading="user.isLoading"
        :label="inviteClanText(user)"
        @click.stop="inviteUser(user)"
      />
    </ListItemAccount>
  </Wrapper>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { invite } from '@/mixins/accountActions/clan';
import ListItemAccount from '@/components/common/ListItemAccount';
import Wrapper from '../ListWrapper';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';

export default {
  name: 'ClanFollowersList',
  components: {
    HeraFormBtn,
    Wrapper,
    ListItemAccount,
  },
  mixins: [invite],
  computed: {
    ...mapState('current', ['account']),
  },
  methods: {
    ...mapActions(['fetchClanFollows']),
    inviteUser(user) {
      this.$set(user, 'isLoading', true);
      this.inviteClanAction({
        account: user,
        accountId: user.login,
      }).then(isInvited => {
        this.$set(user, 'isInvited', isInvited);
        this.$set(user, 'isLoading', false);
      });
    },
  },
};
</script>
